/* ─── Root ─── */

.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.root[data-disabled] {
  opacity: 0.38;
  cursor: not-allowed;
}

/* ─── Label ─── */

.label {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
}

.root[data-invalid] .label {
  color: var(--md-error);
}

/* ─── Input ─── */

.input {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  height: 3rem;
  padding-inline: var(--space-3);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
  background: transparent;
  border: 1px solid var(--md-outline);
  border-radius: var(--shape-xs);
  outline: none;
  transition: border-color var(--motion-duration-short3)
      var(--motion-easing-standard),
    box-shadow var(--motion-duration-short3) var(--motion-easing-standard);
}

.input:focus {
  border-color: var(--md-primary);
  box-shadow: 0 0 0 1px var(--md-primary);
}

.root[data-invalid] .input {
  border-color: var(--md-error);
}

.root[data-invalid] .input:focus {
  border-color: var(--md-error);
  box-shadow: 0 0 0 1px var(--md-error);
}

.root[data-disabled] .input {
  cursor: not-allowed;
}

/* ─── Calendar picker indicator ─── */

.input::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.6;
}

@media (hover: hover) {
  .input::-webkit-calendar-picker-indicator:hover {
    opacity: 1;
  }
}

/* ─── Description ─── */

.description {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface-variant);
  margin: 0;
}

/* ─── Error ─── */

.error {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-error);
  margin: 0;
}
